import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowAccordion: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 15 10"
    sx={{
      width: '15px',
      height: '10px',
      fill: 'none',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M14.7073 1.11306C15.0977 1.50348 15.0975 2.13657 14.7073 2.52712L8.343 8.89138C7.95247 9.2819 7.31946 9.2819 6.92893 8.89138L0.564677 2.52712C0.17445 2.13657 0.174252 1.50348 0.564677 1.11306C0.955103 0.722631 1.58819 0.722829 1.97874 1.11306L7.63597 6.77028L13.2932 1.11306C13.6837 0.72283 14.3168 0.722632 14.7073 1.11306Z"
      fill="#949494"
    />
  </SvgIcon>
);
